import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { customAlphabet } from 'nanoid'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const nanoid = customAlphabet(
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
  7
) // 7-character random string

export const cleanupWebSockets = () => {
  // Force close any open WebSocket connections
  const sockets = Array.from(document.querySelectorAll('*'))
    .filter(el => el.shadowRoot)
    .map(el => el.shadowRoot?.activeElement)
    .filter(el => el instanceof WebSocket)

  sockets.forEach(socket => {
    if (socket && socket instanceof WebSocket) {
      socket.close()
    }
  })
}
